document.addEventListener('DOMContentLoaded', function() {
  function alignElements() {
      var gridItem = document.querySelector('.custom-landing-grid .item:nth-child(2)');
      var heroCaption = document.querySelector('.home .hero-title');
      if (window.innerWidth >= 768) { 
        if (gridItem && heroCaption) {
            var leftOffset = gridItem.getBoundingClientRect().left - gridItem.parentNode.getBoundingClientRect().left;
            heroCaption.style.left = leftOffset + 'px';
        }
      } else {
        if (gridItem && heroCaption) {
            var leftOffset = gridItem.getBoundingClientRect().left - gridItem.parentNode.getBoundingClientRect().left;
            heroCaption.style.left = 'initial';
        }
      }
  }

  var resizeTimer;  // Declare a variable to hold the timeout outside the event handler

  function onResize() {
      clearTimeout(resizeTimer);  // Cancel the previous timeout
      resizeTimer = setTimeout(alignElements, 500);  // Reset the timer
  }

  window.onload = function() {
      // Optionally add a delay to ensure all dynamic content has fully loaded and rendered
      setTimeout(alignElements, 500);  // Adjust as necessary

      // Realign when window is resized, with debouncing
      window.addEventListener('resize', onResize);
  };
});
